import { useCallback } from 'react';
import getLangLocale from 'I18n/utils/getLangLocale';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { ActionConfigTabIds } from 'automation-ui-action-features/constants/ActionConfigTabs';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MAX_ACCURATE_COUNT = 100;
const approximationFormat = new Intl.NumberFormat(getLangLocale(), {
  maximumSignificantDigits: 2
});
function ObjectsInActionCountButton({
  flowObjectTypeId,
  onSelectAction,
  actionId,
  count
}) {
  const openObjectsInActionTab = useCallback(event => {
    // Stop the parent's onClick handler and open objects in action tab
    event.preventDefault();
    event.stopPropagation();
    if (onSelectAction) {
      onSelectAction(actionId, {
        tab: ActionConfigTabIds.DELAYED_OBJECTS
      });
    }
  }, [onSelectAction, actionId]);
  const label = /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
    baseLangKey: "objectsInAction.numberWaitingInAction_cob",
    objectTypeId: flowObjectTypeId,
    options: {
      count,
      approximateCount: approximationFormat.format(count)
    }
  });
  return /*#__PURE__*/_jsx(UIButton, {
    use: "link",
    onClick: openObjectsInActionTab,
    children: count < MAX_ACCURATE_COUNT ? label : /*#__PURE__*/_jsxs(_Fragment, {
      children: [label, /*#__PURE__*/_jsx(HelpIcon, {
        marginInlineStart: "100",
        marginInlineEnd: "0",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "objectsInAction.numberWaitingApproximation"
        })
      })]
    })
  });
}
export default ObjectsInActionCountButton;